<template lang="html">
  <div>
    <v-select v-model="azienda" @search="updateSearch" :required="required"
    label="ragione_sociale"
    :options="aziende"
    :filterable="false"
    placeholder="Seleziona azienda">
    <!-- :reduce="az => az.id"> -->
      <template slot="no-options">
        Ricerca le aziende
      </template>
      <template #search="{attributes, events}">
        <input
          class="vs__search"
          :required="!id && required"
          v-bind="attributes"
          v-on="events"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    required: Boolean,
    all: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      id: this.value || null,
      azienda: this.value || null,
      aziende: [],
      search: _.debounce((a, b, c) => this.doSearch(a, b, c), 350)
    }
  },

  created () {
    if (this.id) {
      let params = { id: this.id, max: 20 }
      this.doSearch(params)
    } else {
      this.doSearch()
    }
  },

  methods: {
    updateSearch (q, loading) {
      loading(true)
      let params = { q, id: this.id ? this.id.id : null, max: 20 }
      this.search(params, loading)
    },

    doSearch(params, loading) {
      this.$http.get(this.all ? 'azienda/all' : 'azienda/all_tiroc', { params }).then(res => {
        this.aziende = res.data
      }).finally(res => {
        loading && loading(false)
      })
    }
  },

  watch: {
    azienda (id) {
      this.$emit('input', id)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
